export const sansthaData = [
	{
		sansthaType: 'Not registered(AOP)',
		acts: ['NA'],
	},
	{
		sansthaType: 'Charitable, Religious Trust',
		acts: [
			'Indian Trusts Act, 1882',
			'Maharashtra Public Trust Act 1950 (earlier Bombay Public Trusts Act, 1950)',
			'Gujarat Public Trusts Act, 2011 (earlier Bombay Public Trusts Act, 1950)',
			'THE RAJASTHAN PUBLIC TRUST ACT, 1959',
			'Andhra Pradesh Charitable and Hindu Religious Institutions and Endowments Act, 1987',
			'Bihar Hindu Religious Trusts Act, 1950',
			'Karnataka Hindu Religious Institutions and Charitable Endowments Act, 1997',
			'Kerala Travancore-Cochin Hindu Religious Institutions Act, 1950',
			'Orissa Hindu Religious Endowments Act, 1951',
			'Tamil Nadu Hindu Religious and Charitable Endowments Act, 1959',
			'Uttar Pradesh Charitable Endowments (Extension of Powers) Act, 1950',
			'Charitable Endowments (U.P. Amendment) Act, 1952',
			'Religious Endowments (Uttar Pradesh Amendment) Act, 1951',
			'Uttar Pradesh Hindu Religious Institutions (Prevention of Dissipation of Properties) (Repeal) Act, 2000',
			'The Madhya Pradesh Public Trusts Act, 1951',
		],
	},
	{
		sansthaType: 'NGO',
		acts: ['COMPANIES ACT 2013'],
	},
	{
		sansthaType: 'Company',
		acts: ['COMPANIES ACT, 1956'],
	},
	{
		sansthaType: 'Society',
		acts: [
			'Societies Registration Act, 1860',
			'Multi-State Societies Registration Bill, 2012',
			'The Karnataka Societies Registration Act, 1960',
			'The West Bengal Societies Registration Act, 1961',
			'The Tamil Nadu Societies Registration Act, 1975',
			'Manipur Societies Registration Act, 1989',
			'The Jammu – Kashmir Societies Registration Act, 1998',
			'Societies Registration (Uttar Pradesh Amendment) Act, 2000',
		],
	},
	{
		sansthaType: 'Registered (AOP)',
		acts: [
			'Registration Act, 1908',
			'Indian Stamp Act, 1899',
			'The Madhya Pradesh Registration Adhiniyam, 1961',
		],
	},
	{
		sansthaType: 'Trust, Wakf',
		acts: [
			'Mussalman Wakf Act, 1923',
			'Mussalman Wakf Validating Act,1913',
			'Wakf Act, 1995',
			'Mussalman Wakf Validating Act, 1930',
		],
	},
]
export const categoryOptions = [
	{ value: 'Cultural', label: 'Cultural' },
	{ value: 'Religious', label: 'Religious' },
	{ value: 'Wedding', label: 'Wedding' },
	{ value: 'General Meeting', label: 'General Meeting' },
	{ value: 'Medical Camp', label: 'Medical Camp' },
	{ value: 'Workshop', label: 'Workshop' },
	{ value: 'Sports', label: 'Sports' },
	{ value: 'Talent Show', label: 'Talent Show' },
	{ value: 'Donation Drive', label: 'Donation Drive' },
	{ value: 'Matrimonial Meet', label: 'Matrimonial Meet' },
	{ value: 'Family Gathering', label: 'Family Gathering' },
	{ value: 'Felicitation', label: 'Felicitation' },
	{ value: 'Blood Donation Camp', label: 'Blood Donation Camp' },
	{ value: 'Free Eye Checkup', label: 'Free Eye Checkup' },
	{ value: 'Housewarming', label: 'Housewarming' },
	{ value: 'Anniversary', label: 'Anniversary' },
	{ value: 'Personal Puja', label: 'Personal Puja' },
]

export const facilityCategories = [
	{
		category: 'Venue',
		facilities: [
			'Marriage Hall / Banquet Hall',
			'Open Ground / Wadi',
			'Community Dining Hall / Bhojanshala',
			'Meeting Hall / Seminar Room',
		],
	},
	{
		category: 'Accommodation',
		facilities: ['Dormitory / Guest House / Dharmshala'],
	},
	{
		category: 'Event Setup',
		facilities: ['Stage & Mandap Setup', 'Event Lighting Equipment'],
	},
	{
		category: 'Audio/Visual',
		facilities: [
			'Sound System / PA Setup',
			'Projector & Screen / Event Display Tools',
			'Photo/Video Kit (Camera, Tripod, etc.)',
		],
	},
	{
		category: 'Catering',
		facilities: ['Utensil Bank / Crockery Set', 'Catering Equipment (Gas stove, Bhagona, etc.)'],
	},
	{
		category: 'Education',
		facilities: [
			'School Classroom (for rent during non-hours)',
			'Computer Lab / Digital Classroom',
			'Library / Study Room',
		],
	},
	{
		category: 'Transport',
		facilities: ['Bus / Van (for events or group travel)'],
	},
	{
		category: 'Health',
		facilities: [
			'Ambulance (free or subsidized for emergencies)',
			'Health Check-up Equipment / Mobile Clinic Setup',
		],
	},
	{
		category: 'Utility',
		facilities: ['Water Filter / RO Facility (for refilling)', 'Generator / Power Backup Unit'],
	},
]

export const designationOptions = [
	{ value: 'president', label: 'President' },
	{ value: 'vice president', label: 'Vice President' },
	{ value: 'secratary', label: 'Secratary' },
	{ value: 'joint secretary', label: 'Joint secretary' },
	{ value: 'treasrer', label: 'Treasrer' },
	{ value: 'joint Treasrer', label: 'Joint Treasrer' },
	{ value: 'managing committee member ', label: 'Managing committee Member' },
	{ value: 'managing trustee', label: 'Managing Trustee' },
	{ value: 'trustee-secratary', label: 'Trustee-Secratary' },
	{ value: 'trustee -joint secretary', label: 'Trustee -Joint secretary' },
	{ value: 'trustee -treasrer', label: 'Trustee -Treasrer' },
	{ value: 'trustee -joint treasrer', label: 'Trustee -Joint Treasrer' },
	{ value: 'trustee', label: 'Trustee' },
	{ value: 'executive trustee', label: 'Executive Trustee' },
	{ value: 'chairman', label: 'Chairman' },
	{ value: 'managing director', label: 'Managing director' },
	{ value: 'director', label: 'Director' },
	{ value: 'executive director', label: 'Executive director' },
	{ value: 'nominated director', label: 'Nominated director' },
	{ value: 'sub admin', label: 'Sub admin' },
]
